// @spec BCP-STR-058
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { BCPExerciseSettingsCard } from '@/features/settings/bcp/components/bcp-exercise-settings-card';
import { useOrgRole } from '@/hooks/use-org-role';
import i18n from '@/lib/i18n';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/settings/bcp-exercise-settings')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.bcpExerciseSettings'),
  }),
  component: BCPExerciseSettingsPage,
});

/**
 * Organization BCP exercise settings page for configuring exercise requirements.
 *
 * Allows organization admins to:
 * - Configure exercise frequencies per plan type
 * - Set criticality-based frequency overrides
 * - Configure required exercise types per plan type
 * - Manage compliance tracking and alerts
 */
function BCPExerciseSettingsPage() {
  const { t } = useTranslation('settings');
  const { isAdmin } = useOrgRole();

  return (
    <div className="p-8">
      <div className="mx-auto max-w-4xl space-y-8">
        <header>
          <h1 className="text-3xl font-semibold text-foreground">
            {t('bcpExerciseSettingsPage.title')}
          </h1>
          <p className="mt-1 text-muted-foreground">{t('bcpExerciseSettingsPage.description')}</p>
        </header>

        <section className="space-y-6">
          <BCPExerciseSettingsCard isAdmin={isAdmin} />
        </section>
      </div>
    </div>
  );
}
